import { useCallback, useEffect, useState } from "react";
import { FetchDashboardHealth } from "../../api/FetchDashboardHealth";
import {
  DashboardHealth,
  DashboardHealthState,
} from "../../helpers/interfaces/DashboardInterfaces";

export const useFetchDashboardHealth = (): DashboardHealthState => {
  const [data, setData] = useState<DashboardHealth | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  const refresh = useCallback(() => setReloadKey((key) => key + 1), []);

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      setLoading(true);
      const result = await FetchDashboardHealth();

      if (cancelled) return;

      const health = result?.data?.data;

      if (health) {
        setData(health);
        setError(null);
      } else {
        setError("Unable to load dashboard data.");
      }

      setLoading(false);
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [reloadKey]);

  return { data, loading, error, refresh };
};
